<template>
	<div id="confirm_cheque" class="all_app p_background clearfix">
		<h3 class="all_title clearfix">
			订单管理
			<span class="cursor pull-right color_9" @click="$router.go(-1)" style="font-size: 14px;">返回</span>
		</h3>
		<section class="all_container container_box">
			<h4 class="title clearfix">
				<span class="pull-left">确认到账<small>请务必认真核对</small></span>
			</h4>
			<section class="content_box">
				<div class="top clearfix">
					<section class="detail_info col-md-6">
						<span class="color_9">购买者：{{buyer.chName}}</span>
					</section>
					<section class="detail_info col-md-6">
						<span class="color_9">联系方式：{{buyer.mobile}}</span>
					</section>
					<section class="detail_info col-md-6">
						<span>应用名称：</span>
						<span class="color_9">{{viewName}}</span>
					</section>
					<section class="detail_info col-md-6">
						<span>应付金额：</span>
						<span class="color_9">{{tCloudAppOrder.orderPrice}}元整</span>
					</section>
					<section class="detail_info col-md-6">
						<span>订购日期：</span>
						<span class="color_9">{{tCloudAppOrder.orderTime | time}}</span>
					</section>
					<section class="detail_info col-md-6">
						<span>支付日期：</span>
						<span class="color_9">{{tCloudAppOrder.payTime | time}}</span>
					</section>
				</div>
				<div class="bottom">
					<div class="clearfix cheque_top">
						<section class="col-md-4">
							<span>支票号码：</span>
							<span class="color_2993ff">{{cheque.chequeNo}}</span>
						</section>
						<section class="col-md-4">
							<span>支票金额：</span>
							<span class="color_2993ff">{{cheque.chequeMoney}}元整</span>
						</section>
						<section class="col-md-4">
							<span>实际金额与应付金额相差：</span>
							<span class="color_2993ff">{{differmoney}}元</span>
						</section>
						<section class="col-md-4">
							<span>支票说明：</span>
							<span class="color_2993ff">{{cheque.remark}}</span>
						</section>
					</div>
					<div class="cheque_bottom">
						<p>支票号码下所有订购应用：</p>
						<section class="table_box">
							<table class="table table-hover table-condensed">
								<thead>
									<tr>
										<th>
											<input type="checkbox" class="radio_input_f" id="order_number" @click="allCheck" name="allCheck" />
											<label class="form_label radio_label" for="order_number">订单编号</label>
										</th>
										<th>应用名称</th>
										<th>应付金额</th>
										<th>是否开通</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item,index) in orderList">
										<td v-if="item.payStatus == '113002'">
											<input @change="changeCheck(index)" type="checkbox" checked="item.payStatus == '113002'" disabled :value="item.id" class="radio_input_f" :id="'order_number_'+index" name="classCheck" />
											<label class="form_label radio_label" :for="'order_number_'+index">{{item.orderNo}}</label>
											<input type="hidden" :value="item.orderPrice" :id="'priceId'+index"/>
										</td>
										<td v-else>
											<input @change="changeCheck(index)" type="checkbox" :value="item.id" class="radio_input_f" :id="'order_number_'+index" name="classCheck" />
											<label class="form_label radio_label" :for="'order_number_'+index">{{item.orderNo}}</label>
											<input type="hidden" :value="item.orderPrice" :id="'priceId'+index"/>
										</td>
										<td>{{item.viewName}}</td>
										<td>{{item.orderPrice}}元整</td>

										<td v-if="item.payStatus == '113002'">已到账</td>
										<td v-else>未到账</td>
									</tr>
								</tbody>
							</table>
						</section>
						<section class="total_box">
							<div class="total">
								合计：{{totalpayable}}元整
							</div>
						</section>
						<section class="btn_box text-right">
							<button class="btn btn_issue" @click="dredgeApp">确认到账</button>
						</section>
					</div>
				</div>
			</section>
		</section>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	export default {
		data() {
			return {
				orderId: this.$route.params.orderId,
				chequeId: this.$route.params.chequeId,
				userId: this.$route.params.userId,
				viewName: this.$route.params.viewName,
				tCloudAppOrder: '',
				buyer: '',
				cheque: '',
				orderList: '',
				totalpayable: 0, //应付合计
				differmoney: 0, //金额相差
				sumOrderPrice: ''//总支付金额
			}
		},
		created() {
			var temp = this;
			this.managerSetTCloudAppPayStatus(function() {
				temp.getDifferInit();
			});
		},
		mounted: function() {
			this.$nextTick(function() {
				
			})
		},
		methods: {
			allCheck() {
				var e = event || window.event;
				var obj = e.srcElement ? e.srcElement : e.target;
				var checkId = document.getElementById("order_number");
				var checklist = document.getElementsByName("classCheck");
				var priceSum = 0;
				
				if(obj.id != "order_number") {
					checkId.checked = false;
				} else {
					if(checkId.checked) {
						$("input[id^='priceId']").each(function(){
							priceSum = priceSum + (parseInt($(this).val()));
						})
						this.totalpayable = priceSum;
						for(var i = 0; i < checklist.length; i++) {
							checklist[i].checked = true;
						}
					} else {
						this.totalpayable = this.sumOrderPrice;
						for(var j = 0; j < checklist.length; j++) {
							if(!$(checklist[j]).attr('disabled')){
								checklist[j].checked = false;
							}
						}
					}
				}
			},
			changeCheck(index) {
				var selectChks = $("input[type=checkbox][name=classCheck]");
				var all = $("input[type=checkbox][name=allCheck]");
				if(selectChks[index].checked){
					this.totalpayable = this.totalpayable + parseInt($(selectChks[index]).next().next().val());
				}else{
					this.totalpayable = this.totalpayable - parseInt($(selectChks[index]).next().next().val());
				}
				for(var i = 0; i < selectChks.length; i++) {
					if(!selectChks[i].checked) {
						all[0].checked = false;
						return;
//						this.totalpayable = this.sumOrderPrice;
					}
				}
				all[0].checked = true;
			},
			getDifferInit() {
				//计算差额
				var differ = this.cheque.chequeMoney - this.sumOrderPrice - this.tCloudAppOrder.orderPrice;
				if(differ > 0) {
					this.differmoney = "+" + differ;
				} else if(differ < 0) {
					this.differmoney = differ;
				}
				if(this.sumOrderPrice > 0){
					this.totalpayable = this.sumOrderPrice
				}
			},
//			calculateTotalpayable() {
//				var receiving = 0;
//				var selectChks = $("input[name='classCheck']:checked");
//				for(var i = 0; i < selectChks.length; i++) {
//					var k = $(selectChks[i]).next().next().val();
//					receiving += parseInt(k);
//				}
//				this.totalpayable = receiving; //应付总额
//				if(this.sumOrderPrice > 0){
//					this.totalpayable = this.sumOrderPrice
//				}
//			},
			//开通 是默认开通当前应用
			dredgeApp() {
				//				var selectChks = $("input[type=checkbox][name=classCheck]:checked");
				//				if(selectChks.length == 0) {
				//					MessageBox({
				//						showClose: true,
				//						message: '请至少勾选一个！',
				//						type: 'warning'
				//					});
				//					return false;
				//				}
				//				var receiving = '';
				//				for(var i = 0; i < selectChks.length; i++) {
				//					receiving += selectChks[i]['value'];
				//					if(i < selectChks.length - 1) {
				//						receiving += ','
				//					}
				//				}
				var temp = this;
				if(temp.cheque.chequeMoney - temp.sumOrderPrice - temp.tCloudAppOrder.orderPrice >= 0) {
					temp.$http.post('/zklccloud/managerChangeTCloudAppPayStatus', {
						"orderIds": temp.orderId
					}, {
						emulateJSON: true
					}).then(function(m) {
						if(m.body.resultCode == -1){
							MessageBox({
								showClose: true,
								message: '该应用已确认到账！',
								type: 'info'
							});
						}else{
							temp.managerSetTCloudAppPayStatus(function() {
								temp.getDifferInit();
							});
							MessageBox({
								showClose: true,
								message: '操作成功！',
								type: 'success'
							});
						}
						
					})
				} else {
					MessageBox({
							showClose: true,
							message: '支票价格不足支付订单金额！',
							type: 'error'
						});
				}
			},
			managerSetTCloudAppPayStatus(callback) {
				var temp = this;
				temp.$http.post('/zklccloud/managerSetTCloudAppPayStatus', {
					"orderId": temp.orderId,
					"chequeId": temp.chequeId,
					"userId": temp.userId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.tCloudAppOrder = m.body.content.tCloudAppOrder;
					temp.buyer = m.body.content.buyer;
					temp.cheque = m.body.content.cheque;
					temp.orderList = m.body.content.orderList;
					temp.sumOrderPrice = m.body.content.sumOrderPrice;
					if(callback) {
						callback();
					}
				})
			},
		}
	}
</script>

<style scoped>
	#confirm_cheque .btn_box {
		margin-bottom: 15px;
	}
	
	#confirm_cheque .title {
		margin-bottom: 15px;
	}
	
	#confirm_cheque .content_box .top,
	#confirm_cheque .content_box .bottom {
		margin-bottom: 15px;
		border: 1px dashed #ccc;
		padding-top: 10px;
	}
	
	#confirm_cheque .content_box .top>* {
		margin-bottom: 10px;
	}
	
	#confirm_cheque .content_box .bottom .table_box {
		border: 0 none;
	}
	
	.table>thead>tr>th {
		border: 0 none;
		text-align: left;
	}
	
	.cheque_top {
		padding-bottom: 10px;
		border-bottom: 1px dashed #ccc;
	}
	
	.cheque_top>* {
		margin-bottom: 10px;
	}
	
	.cheque_bottom {
		padding: 10px 15px;
	}
	
	.total_box {
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// confirm_cheque.vue?72ed9df0